/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, Dispatch, SetStateAction } from "react";
import { Answer, Hits } from "../../types/busqueda-elastic/RespuestaElastic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { toaster, Loader } from "rsuite";
import { Row, Col } from "react-bootstrap";
import { Table } from "react-bootstrap";
import Paging from "../../components/Datatable/Paging";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ModalDetailFile from "../../components/Modals/ModalDetailFile";
import peticionBack from "../../libs/peticiones/peticionBack";
import { eliminarTildes } from "../../libs/formats";
import { addHours, format } from "date-fns";
import { es } from "date-fns/locale";
import { defaultStatus, statusAudio } from "../../pages/visualizar-archivos/Main";
import { Status } from "../../enums/Status";

const TableElasticSearch = ({
  paging = true,
  info = true,
  petition,
  lengthMenu = [
    { v: 5, l: 5 },
    { v: 10, l: 10 },
    { v: 20, l: 20 },
    { v: 50, l: 50 },
    { v: 100, l: 100 },
  ],
  // refresh,
  // setRefresh,
  textSearch = "",
  stateRefresh,
  searching,
  setSearching,
}: {
  lengthMenu?: Array<{ v: number; l: number }>;
  // refresh: boolean;
  // setRefresh: Dispatch<SetStateAction<boolean>>;
  paging?: boolean;
  info?: boolean;
  pageLength?: number;
  petition?: Function;
  stateRefresh?: [boolean, Dispatch<SetStateAction<boolean>>];
  textSearch: string;
  searching: boolean;
  setSearching: Dispatch<SetStateAction<boolean>>;
}) => {
  let [refresh, setRefresh] = [null, null] as
    | [boolean, Dispatch<SetStateAction<boolean>>]
    | Array<null>;
  if (stateRefresh) {
    [refresh, setRefresh] = stateRefresh;
  }

  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageItems] = useState([] as any[]);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [offset, setOffset] = useState(0);
  const [elasticResponse, setElasticResponse] = useState<Answer | null>(null);
  const [loading, setLoading] = useState(false);
  const [openedFile, setOpenedFile] = useState<any>();
  const [modalFile, setModalFile] = useState<boolean>(false);
  const [loadingModal, setloadingModal] = useState<any>();
  const [textSearched, settextSearched] = useState<string>("");
  const [terms, setTerms] = useState<Array<string>>([]);
  const [typeDocument, setTypeDocument] = useState<string>("");
  const [stateAudio, setStateAudio] = useState<statusAudio>(defaultStatus);

  useEffect(() => {
    if (textSearch !== null && textSearch !== undefined && textSearch !== "") {
      if (refresh === true) {
        if (petition && refresh === true) {
          if (setRefresh) {
            setRefresh(false);
          }

          settextSearched(textSearch);

          getDataPetition(itemsPerPage, currentPage);
        }
      }
    }
  }, [refresh]);

  useEffect(() => {
    if (textSearch !== null && textSearch !== undefined && textSearch !== "") {
      getDataPetition(itemsPerPage, itemsPerPage * currentPage);
    }
  }, [currentPage, itemsPerPage]);

  function formatDate(dateStr: string) {
    return format(new Date(dateStr), "PPP", { locale: es });
  }

  async function getDataPetition(itemsPerPage: number, currentPage: number) {
    setLoading(true);
    // if (!loading) {
    // }
    if (petition) {
      const data = (await petition(itemsPerPage, currentPage)) as Answer;
      if (data !== null) {
        if (data.terms) {
          setTerms(data.terms);
        }

        if (data.typeDocument) {
          setTypeDocument(data.typeDocument);
        }
        // setCollapses(Array(data.data.hits.hits.length).fill(false));

        setElasticResponse(data);
        if (!searching) {
          setSearching(true);
        }
      } else {
        setElasticResponse(null);
      }
    }
    setLoading(false);
  }

  useEffect(() => {
    if (openedFile) setModalFile(true);
  }, [openedFile]);

  async function openFile(id: string) {
    setloadingModal(true);
    peticionBack({}, `/files/${encodeURIComponent(id)}`, "GET", false, toaster)
      .then((res) => {
        setOpenedFile({
          pages: res.ocr.data,
          type: res.mimetype.split("/")[1].toUpperCase(),
          status: res.status,
          src: res.src,
          tag: res.tag,
          name: res.ocr.name,
          _id: res._id,
          id: id,
          jurisprudence: res.jurisprudence || "",
          folderType: res.folder_type.name || "",
          number: res.number || "",
          year: res.year || "",
        });
        if (res.tts) {
          setStateAudio(res.tts);
        } else {
          setStateAudio({ ...stateAudio, status: Status.NO_PROCESS });
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setloadingModal(false));
  }

  function getItemsPagging() {
    if (!elasticResponse?.data.hits.hits?.length) {
      return 0;
    }

    if (elasticResponse.data.hits.total.value) {
      return elasticResponse.data.hits.total.value;
    } else {
      return 0;
    }
  }

  function getErrorComponent(msg: string) {
    return (
      <div className="d-flex  flex-column justify-content-center align-items-center text-center">
        <h2>{msg}</h2>
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          style={{ color: "#ff0000" }}
          size="9x"
        />
      </div>
    );
  }

  function getPositionsTextFound(textSearched: string, textFound: string) {
    let flag = true;
    let init = 0;
    const indexes = [];
    const texts: Array<{ text: string; isMatch: boolean }> = [];

    while (flag) {
      const index = eliminarTildes(textFound.toLowerCase()).indexOf(
        textSearched,
        init
      );
      if (index !== -1) {
        texts.push({
          text: textFound.substring(init, Number(index)),
          isMatch: false,
        });
        const newInit = Number(index) + textSearched.length;
        indexes.push({
          start: Number(index),
          end: newInit,
        });
        texts.push({
          text: textFound.substring(Number(index), newInit),
          isMatch: true,
        });

        init = newInit;
      } else {
        flag = false;
      }
    }
    if (indexes[indexes.length - 1].end < textFound.length) {
      texts.push({
        text: textFound.substring(init, textFound.length),
        isMatch: false,
      });
    }

    // return indexes;

    return texts;
  }
  function getContentElement(
    textSearchedCleaned: string,
    textFound: string,
    page: number
  ) {
    const listTextToPrint = getPositionsTextFound(
      textSearchedCleaned,
      textFound
    );
    return (
      <Row className="text-justify mb-3 mt-3 border-top border-black">
        <Row className="mt-3">
          <Col
            xs={2}
            md={2}
            className="text-center d-flex align-items-center justify-content-center"
          >
            <h5>{page}</h5>
          </Col>
          <Col xs={10} md={10}>
            {listTextToPrint.map((text, index) => (
              <span
                key={"pst" + page + index}
                className={text.isMatch ? "bg-primary text-white" : ""}
              >
                {text.text}
              </span>
            ))}
          </Col>
        </Row>
      </Row>
    );
  }

  function getFirst5Clean(element: Hits, textSearchedCleaned: string) {
    let hits: Array<any> = [];
    let cont = 0;
    while (hits.length < 5 && cont < element._source.data.length) {
      if (typeof element._source.data[cont].text === "string") {
        if (
          element._source.data &&
          element._source.data[cont] &&
          element._source.data[cont].text &&
          eliminarTildes(
            element._source.data[cont].text.toString().toLowerCase()
          ).includes(textSearchedCleaned)
        ) {
          hits.push({
            text: element._source.data[cont].text.toString(),
            page: element._source.data[cont].page,
          });
        }
      } else {
        if (
          element._source.data &&
          element._source.data[cont] &&
          element._source.data[cont].text &&
          eliminarTildes(
            element._source.data[cont].text.join().toLowerCase()
          ).includes(textSearchedCleaned)
        ) {
          hits.push({
            text: element._source.data[cont].text.join(),
            page: element._source.data[cont].page,
          });
        }
      }

      cont++;
    }

    return hits;

    // let filter = element._source.data
    //   .filter(
    //     (element, index) =>
    //       element.text
    //         .join()
    //         .toLowerCase()
    //         .includes(eliminarTildes(textSearched.toLowerCase())) && index > 5
    //   )
    //   .slice(0, 5);
  }

  function markTexts(element: Hits) {
    let textSearchedCleaned = eliminarTildes(textSearched.toLowerCase());
    let filter = getFirst5Clean(element, textSearchedCleaned);
    return filter.map((result) => {
      return getContentElement(textSearchedCleaned, result.text, result.page);
    });
  }

  function getFirst5CleanMultiWord(element: Hits, words: Array<string>) {
    let hits: Array<any> = [];
    let cont = 0;

    while (hits.length < 5 && cont < element._source.data.length) {
      if (typeof element._source.data[cont].text === "string") {
        if (
          words.some((palabra) =>
            eliminarTildes(
              element._source.data[cont].text.toString().toLowerCase()
            ).includes(palabra)
          )
        ) {
          hits.push({
            text: element._source.data[cont].text,
            page: element._source.data[cont].page,
          });
        }
      } else {
        if (
          words.some((palabra) =>
            eliminarTildes(
              element._source.data[cont].text.join().toLowerCase()
            ).includes(palabra)
          )
        ) {
          hits.push({
            text: element._source.data[cont].text.join(),
            page: element._source.data[cont].page,
          });
        }
      }
      cont++;
    }
    return hits;
  }

  function getWords(words: Array<string>, textFound: string, init: number) {
    return words
      .map((word) => {
        return {
          indx: eliminarTildes(textFound).toLowerCase().indexOf(word, init),
          lengthWord: word.length,
        };
      })
      .filter((indexWord) => indexWord.indx !== -1)
      .sort(function (a, b) {
        return a.indx - b.indx;
      });
  }

  function getPositionsTextFoundMultiWords(
    words: Array<string>,
    textFound: string
  ) {
    let flag = true;
    let init = 0;
    const texts: Array<{ text: string; isMatch: boolean }> = [];

    while (flag) {
      let indexes = getWords(words, textFound, init);

      if (indexes.length > 0) {
        indexes.forEach((indx) => {
          texts.push({
            text: textFound.substring(init, Number(indx.indx)),
            isMatch: false,
          });
          let newInit = Number(indx.indx) + indx.lengthWord;
          texts.push({
            text: textFound.substring(Number(indx.indx), newInit),
            isMatch: true,
          });
          init = newInit;
        });
      } else {
        flag = false;
      }

      if (
        indexes.length > 0 &&
        indexes[indexes.length - 1].indx < textFound.length
      ) {
        texts.push({
          text: textFound.substring(
            indexes[indexes.length - 1].indx +
              indexes[indexes.length - 1].lengthWord,
            textFound.length
          ),
          isMatch: false,
        });
      }
    }

    return texts;
  }

  function getContentElementMultiWords(
    words: Array<string>,
    textFound: string,
    page: number
  ) {
    const listTextToPrint = getPositionsTextFoundMultiWords(words, textFound);

    // return <div>f</div>;
    return (
      <Row className="text-justify mb-3 mt-3 border-top border-black">
        <Row className="mt-3">
          <Col
            xs={2}
            md={2}
            className="text-center d-flex align-items-center justify-content-center"
          >
            <h5>{page}</h5>
          </Col>
          <Col xs={10} md={10}>
            {listTextToPrint.map((text, index) => (
              <span
                key={"pst" + page + index}
                className={text.isMatch ? "bg-primary text-white" : ""}
              >
                {text.text}
              </span>
            ))}
          </Col>
        </Row>
      </Row>
    );
  }

  function markTextsMultiWords(element: Hits) {
    let words = terms;
    let filter = getFirst5CleanMultiWord(element, words);

    return filter.map((result) => {
      return getContentElementMultiWords(words, result.text, result.page);
    });
  }

  return (
    <div>
      {searching ? (
        <div>
          {!loading ? (
            <>
              {elasticResponse === null ? (
                getErrorComponent("Algo salio mal")
              ) : (
                <>
                  {elasticResponse.data.hits.hits.length === 0 ? (
                    <>{getErrorComponent("No se encontraron resultados")}</>
                  ) : (
                    <>
                      <div className="searchResultsTitle">RESULTADOS DE BÚSQUEDA</div>
                      <div className="searchTableCard">
                      <Table responsive>
                        <thead>
                          {typeDocument === "TÉSIS AISLADAS Y DE JURISPRUDENCIA" ? (
                            <tr>
                              <th
                                className=" text-center">
                                Clave
                              </th>
                              <th
                                className=" text-center">
                                Órgano emisor
                              </th>
                              <th
                                className=" text-center">
                                Materia
                              </th>
                              <th
                                className=" text-center">
                                Jurisprudencia
                              </th>
                              {/* <th
                                className=" text-center">
                                Tipo de jurisprudencia
                              </th> */}
                              <th
                                className=" text-center">
                                Fecha de publicación
                              </th>
                              <th
                                className=" text-center">
                                Año
                              </th>
                              <th
                                className=" text-center">
                                Época
                              </th>

                              <th
                                className=" text-center">
                                Ver Archivo
                              </th>
                            </tr>
                          ) : typeDocument === "SENTENCIA" ? (
                            <tr className="text-center">
                              <th
                                className=" text-center">
                                Órgano jurisdiccional
                              </th>
                              <th
                                className=" text-center">
                                Distrito
                              </th>
                              <th
                                className=" text-center">
                                Instancia
                              </th>
                              <th
                                className=" text-center">
                                Fecha ejecutoria
                              </th>
                              <th
                                className=" text-center">
                                Fecha de publicación
                              </th>
                              <th
                                className=" text-center">
                                Tipo de carpeta
                              </th>
                              <th
                                className=" text-center">
                                Número / Año
                              </th>
                              <th
                                className=" text-center">
                                Ver Archivo
                              </th>
                            </tr>
                          ) : (
                            <tr className="text-center">
                              <th
                                className=" text-center">
                                Órgano jurisdiccional
                              </th>
                              <th
                                className=" text-center">
                                Distrito
                              </th>
                              <th
                                className=" text-center">
                                Materia
                              </th>
                              <th
                                className=" text-center">
                                Número
                              </th>
                              <th
                                className=" text-center">
                                Año
                              </th>
                              <th
                                className=" text-center">
                                Ver Archivo
                              </th>
                            </tr>
                          )}
                        </thead>
                        <tbody>
                          {elasticResponse.data.hits.hits.map(
                            (element, index) => (
                              <>
                                {typeDocument === "TÉSIS AISLADAS Y DE JURISPRUDENCIA" ? (
                                  <tr
                                    className="text-center bg-success"
                                    style={{ backgroundColor: "blue" }}
                                    key={"TAB" + index}
                                  >
                                    <td>
                                      {
                                        element._source.infoElastic
                                          .jurisprudenceKey
                                      }
                                    </td>
                                    <td>{element._source.infoElastic.area}</td>
                                    <td>
                                      {element._source.infoElastic.subject}
                                    </td>
                                    <td>
                                      {
                                        element._source.infoElastic
                                          .jurisprudence
                                      }
                                    </td>
                                    {/* <td>
                                      {
                                        element._source.infoElastic
                                          .jurisprudenceType
                                      }
                                    </td> */}
                                    <td>
                                      {element._source.infoElastic.publication
                                        ? formatDate(
                                            element._source.infoElastic
                                              .publication
                                          )
                                        : "-"}
                                    </td>
                                    <td>{`${
                                      element._source.infoElastic.year
                                        ? element._source.infoElastic.year
                                        : "-"
                                    }`}</td>
                                    <td>{element._source.infoElastic.epoch}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="searchIconBtn"
                                        onClick={() => openFile(element._source.idMongo)}
                                      >
                                        <FontAwesomeIcon icon={faFile} />
                                      </button>
                                    </td>
                                  </tr>
                                ) : typeDocument === "SENTENCIA" ? (
                                  <tr
                                    className="text-center bg-success"
                                    style={{ backgroundColor: "blue" }}
                                  >
                                    <td>{element._source.infoElastic.area}</td>
                                    <td>
                                      {element._source.infoElastic.district}
                                    </td>
                                    <td>
                                      {element._source.infoElastic.instance}
                                    </td>
                                    <td>
                                      {formatDate(
                                        element._source.infoElastic.execution
                                      )}
                                    </td>
                                    <td>
                                      {formatDate(
                                        element._source.infoElastic.registration
                                      )}
                                    </td>
                                    <td>
                                      {element._source.infoElastic.folderType}
                                    </td>
                                    <td>
                                      {element._source.infoElastic.number &&
                                      element._source.infoElastic.year
                                        ? `${element._source.infoElastic.number} /${element._source.infoElastic.year}`
                                        : ""}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="searchIconBtn"
                                        onClick={() => openFile(element._source.idMongo)}
                                      >
                                        <FontAwesomeIcon icon={faFile} />
                                      </button>
                                    </td>
                                    {/* <td>{`${element._source.number} /${element._source.year}`}</td> */}
                                  </tr>
                                ) : (
                                  <tr className="text-center bg-success">
                                    <td>
                                      {element._source?.infoElastic?.area}
                                    </td>
                                    <td>
                                      {element._source?.infoElastic?.district ||
                                        "-"}
                                    </td>
                                    <td>
                                      {element._source?.infoElastic?.subject ||
                                        "-"}
                                    </td>
                                    <td>
                                      {element._source?.infoElastic?.number ||
                                      "-"
                                        ? element._source?.infoElastic
                                            ?.number || "-"
                                        : "-"}
                                    </td>
                                    <td>
                                      {element._source?.infoElastic?.year || "-"
                                        ? element._source?.infoElastic?.year ||
                                          "-"
                                        : "-"}
                                    </td>
                                    <td>
                                      <div className="d-flex justify-content-around align-items-center ">
                                        <button
                                          type="button"
                                          className="searchIconBtn"
                                          onClick={() => openFile(element._source.idMongo)}
                                        >
                                          <FontAwesomeIcon icon={faFile} />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                )}

                                {/* <Animation.Collapse in={collapses[index]}>
                            {(props, ref) => (
                              <tr ref={ref} {...props}>
                                <td colSpan={10}>
                                  <div
                                    style={{
                                      maxHeight: 200,
                                      minHeight: 200,
                                      height: 200,
                                      overflow: "auto",
                                      minWidth: "100%",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    <Row>
                                      <Col
                                        xs={2}
                                        md={2}
                                        className="text-center"
                                      >
                                        <h5>Página</h5>
                                      </Col>
                                      <Col
                                        xs={10}
                                        md={10}
                                        className="text-center"
                                      >
                                        <h5>Contenido</h5>
                                      </Col>
                                    </Row>

                                    {typeSearch === "match" ? (
                                      <div>{markTexts(element)}</div>
                                    ) : (
                                      <div>{markTextsMultiWords(element)}</div>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Animation.Collapse> */}
                                <tr style={{ display: "none" }}></tr>
                              </>
                            )
                          )}
                        </tbody>
                      </Table>

                      <Row>
                        <Paging
                          lengthMenu={lengthMenu}
                          currentPage={currentPage}
                          currentPageItems={currentPageItems}
                          setCurrentPage={setCurrentPage}
                          itemsPerPage={itemsPerPage}
                          setItemsPerPage={setItemsPerPage}
                          items={getItemsPagging()}
                          paging={paging}
                          info={info}
                          offset={offset}
                          setOffset={setOffset}
                        />
                      </Row>
                      </div>
                      <ModalDetailFile
                        archivo={openedFile}
                        stateShow={[modalFile, setModalFile]}
                        title
                        hookStateAudio={[stateAudio, setStateAudio]}
                        textSearch={textSearch}
                      />
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <div className="d-flex  flex-column justify-content-center align-items-center text-center">
              <h2 className="mb-3">Buscando...</h2>
              <FontAwesomeIcon
                icon={faArrowsRotate}
                spin
                style={{ color: "#7680E6" }}
                size="9x"
              />
            </div>
          )}
          {loadingModal && <Loader center backdrop style={{ zIndex: 5 }} />}
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default TableElasticSearch;
